<template>
    <div>
        <painel-erros-dotacoes
            :dotacoes="despViagens ? despViagens.rateiosDespViagens : []"
        ></painel-erros-dotacoes>
        <desp-viagens
            :despViagens="despViagens ? despViagens.despViagens : []"
            :movimentosServicos="movimentosServicos"
            :mostrarAcoes="false"
        ></desp-viagens>
    </div>
</template>

<script>
import PainelErrosDotacoes from './PainelErrosDotacoes'
import DespViagens from '../despviagens/DespViagens'

export default {
    props: {
        despViagens: {
            type: Object,
            default: () => {}
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            tabIndex: 0
        }
    },

    methods: {},

    computed: {},

    created() {},

    watch: {},

    components: {
        PainelErrosDotacoes,
        DespViagens
    }
}
</script>
